import {createInputFile} from "@/lib/util/util";
import {App} from "antd";
import {requestUploadImage} from "@/lib/api/member";
import {useUserInfo} from "@/hooks/useUserInfo";

type UploadAvatarParams = {
    size: number;
    accept: string[];
    setLoading?: (loading: boolean) => void;
}

export const useUploadImages = () => {

    const {message} = App.useApp();
    const {uploadMemberInfo} = useUserInfo();

    // 上传头像
    const uploadAvatar = (params: UploadAvatarParams) => {
        const fileInput = createInputFile(params.accept.join(","));
        fileInput.click();
        fileInput.onchange = async (e: Event) => {
            const target = e.target as HTMLInputElement;
            const files = target.files;
            if (files && files.length > 0) {
                const file = files[0];
                if (file.size > params.size) {
                    message.error("图片大小不能超过" + (params.size / Math.pow(params.size, 2)) + "MB");
                    return;
                }
                await uploadApi(file);
            }
        };

        const uploadApi = async (file: File) => {
            try {
                params?.setLoading?.(true);
                const formData = new FormData();
                formData.append("file", file);
                const res = await requestUploadImage(formData);
                if (res.code !== 200) {
                    message.error(res.message);
                } else {
                    await uploadMemberInfo({
                        member: {
                            head_portrait: res.data.url
                        }
                    });
                }
            } finally {
                params?.setLoading?.(false);
            }
        };
    };

    return {
        uploadAvatar
    };
};

